import styled, { css } from 'styled-components'

export const ClickableContainer = styled.div<{ $isClickable?: boolean }>`
	${(p) =>
		p.$isClickable &&
		css`
			cursor: pointer;
		`}
`
